import { NgModule } from "@angular/core";
import { CheckboxControlComponent } from "./checkbox-control/checkbox-control.component";
import { InputControlComponent } from "./input-control/input-control.component";
import { RadioControlComponent } from "./radio-control/radio-control.component";
import { SelectControlComponent } from "./select-control/select-control.component";
import { SwitchControlComponent } from "./switch-control/switch-control.component";
import { RangeSliderComponent } from "./range-slider/range-slider.component";
import { TextareaControlComponent } from "./texarea-control/texarea-control.component";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { PipesModule } from "src/app/common/pipes/pipes.module";
import { UiIconModule } from "../ui-icon/ui-icon.module";

@NgModule({
    declarations: [
        CheckboxControlComponent,
        InputControlComponent,
        RadioControlComponent,
        SelectControlComponent,
        SwitchControlComponent,
        RangeSliderComponent,
        TextareaControlComponent
    ],
    imports: [
       TranslateModule,
       CommonModule,
       PipesModule,
       UiIconModule
    ],
    exports: [
        CheckboxControlComponent,
        InputControlComponent,
        RadioControlComponent,
        SelectControlComponent,
        SwitchControlComponent,
        RangeSliderComponent,
        TextareaControlComponent
    ]

})

export class UiFormModule {}
